const LOCAL_STORAGE_KEY = "currentUser";

export function preserveLoginData(loginData) {
  if (!loginData) return;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(loginData));
}

export function deleteLoginData() {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
}

export function getLoginData() {
  const data = localStorage.getItem(LOCAL_STORAGE_KEY);
  return data ? JSON.parse(data) : null;
}
